// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__zDpcZ","modal":"style_modal__rTnE-","modal-content":"style_modal-content__HrOLc","close":"style_close__y95Jx","container":"style_container__UzKxl"};